import { create } from 'zustand'
import { BaseBrazeCard } from './types'

type BrazeState = {
  isLoading: boolean
  isError: boolean
  cards: BaseBrazeCard[] | undefined
}

type BrazeActions = {
  setBrazeState: (state: Partial<BrazeState>) => void
}

export const useBrazeStore = create<BrazeState & BrazeActions>((set) => ({
  isLoading: true,
  isError: false,
  cards: undefined,
  setBrazeState: (newState) => set(newState),
}))
